import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'prg-titled-container',
  templateUrl: './titled-container.component.html',
  styleUrls: ['./titled-container.component.less']
})
export class TitledContainerComponent implements OnInit {

  @Input() title: string;
  @Input() leftIcon: string;
  @Input() leftText: string;
  @Input() rightIcon: string;
  @Input() rightText: string;

  @Input() titleClass: string;
  @Input() showHeader: boolean;

  @Output() leftAction: EventEmitter<any>;
  @Output() rightAction: EventEmitter<any>;

  constructor() {
    this.title = '';
    this.leftIcon = '';
    this.leftText = '';
    this.rightIcon = '';
    this.rightText = '';
    this.titleClass = 'centered';
    this.showHeader = false;

    this.leftAction = new EventEmitter<any>();
    this.rightAction = new EventEmitter<any>();
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/common/titled-container/titled-container.component.ts